module.exports = __webpack_public_path__ + "static/media/CyclonX-RC-4402.38c4d718.png";